import { AiFillHome } from "react-icons/ai";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { CgDockBottom } from "react-icons/cg";
import {
  FaBars,
  FaBloggerB,
  FaBriefcase,
  FaProjectDiagram,
  FaThList,
  FaUserFriends,
} from "react-icons/fa";
import { MdPermContactCalendar } from "react-icons/md";
import {
  MdContentPaste,
  MdHomeWork,
  MdOutlineContentPaste,
  MdOutlineMiscellaneousServices,
  MdPersonSearch,
} from "react-icons/md";
import { RiGalleryFill, RiListSettingsFill, RiTeamFill } from "react-icons/ri";
import { SiBloglovin, SiMicrosoftteams } from "react-icons/si";
import { TiThListOutline } from "react-icons/ti";
import { BiDonateHeart } from "react-icons/bi";

export const RoutePath = {
  navBar: "navBar",
  homeBanner: "home-banner",
  about: "about",
  csrFocus: "csr/focus",
  addCsrFocus: "csr/focus/add",
  dynamicCsrFocus: "csr/focus/:id",

  csrWorks: "csr/works",
  addCsrWorks: "csr/works/add",
  dynamicCsrWorks: "csr/works/:id",

  csrHighlights: "csr/highlights",
  addCsrHighlights: "csr/highlights/add",
  dynamicCsrHighlights: "csr/highlights/:id",

  csrCollaboration: "csr/collaboration",

  serviceContent: "serviceContent",
  serviceList: "serviceList",
  dynamicService: "serviceList/:title",

  //wahid
  packageContent: "packageContent",
  packageList: "packageList",
  dynamicPackage: "packageList/:id",
  addPackage: "/addPackage",

  projectContent: "projectContent",
  projectList: "projectList",
  dynamicProject: "projectList/:id",
  addProject: "/addProject",

  teamContent: "teamContent",
  teamList: "teamList",
  dynamicTeam: "teamList/:id",
  addMember: "/addMember",

  expectation: "expectation",

  clients: "clients",
  addClients: "clients/add",
  dynamicClient: "clients/:id",

  clientsReview: "client/review",
  addReview: "client/review/add",
  dynamicClientsReview: "client/review/:id",

  gallery: "gallery",

  blogsContent: "BlogsContent",
  blogList: "blogList",
  dynamicBlog: "blogList/:id",
  addBlog: "/addBlog",

  career: "career",
  jobs: "jobs",
  addJobs: "/addJobs",
  editJobs: "/editJobs/:id",
  job: "job/:id",
  contact: "contact",
  footer: "footer",

  manageUser: "/manage-users",
  dynamicUser: "manage-users/:id",
  addUser: "/addUser",

  login: "login",
};

export const apiPath = {
  navBarApi: "navigation",
  bannerApi: "home/banner",
  aboutApi: "about",
  CSRApi: "about/csr",

  // wahid
  packageApi: "package",

  serviceContentApi: "service/content",
  serviceListApi: "service/list",

  projectContentApi: "projects/content",
  projectListApi: "projects/list",

  teamContentApi: "team/content",
  teamListApi: "team/list",

  expectationApi: "expectation",
  clientsApi: "clients",
  clientsReviewApi: "clients/review",
  galleryApi: "gallery",

  blogsContentApi: "blog/content",
  blogListApi: "blog/list",

  careerApi: "career",
  jobsApi: "career/jobs",
  footerApi: "footer",
  users: "user/list",
  userAdd: "user/create",
};

export const sideBarNavigation = [
  //title, url, content
  [["NavBar", RoutePath.navBar, <FaBars />]],
  [["Home Banner", RoutePath.homeBanner, <AiFillHome />]],
  [["About", RoutePath.about, <BsFillInfoCircleFill />]],
  [
    ["CSR", "", <BiDonateHeart />],
    ["Our focus", RoutePath.csrFocus, <BiDonateHeart />],
    ["Our works", RoutePath.csrWorks, <BiDonateHeart />],
    // ["Highlights", RoutePath.csrHighlights, <BiDonateHeart />],
    ["Collaboration", RoutePath.csrCollaboration, <BiDonateHeart />],
  ],

  [
    ["Service", "", <MdOutlineMiscellaneousServices />],
    ["Service Content", RoutePath.serviceContent, <MdOutlineContentPaste />],
    ["Service List", RoutePath.serviceList, <RiListSettingsFill />],
  ],

  // wahid
  [
    ["Package", "", <MdOutlineMiscellaneousServices />],
    ["Package Content", RoutePath.packageContent, <MdOutlineContentPaste />],
    ["Package List", RoutePath.packageList, <RiListSettingsFill />],
  ],

  [
    ["Projects", "", <FaProjectDiagram />],
    ["Projects Content", RoutePath.projectContent, <MdContentPaste />],
    ["Project List", RoutePath.projectList, <FaThList />],
  ],
  [
    ["Teams", "", <SiMicrosoftteams />],
    // ["Team Content", RoutePath.teamContent, <MdPersonSearch />],
    ["Team List", RoutePath.teamList, <RiTeamFill />],
  ],
  // [["Expectation", RoutePath.expectation, <GiThink />]],
  [
    ["Clients", "", <FaUserFriends />],
    ["Our Clients", RoutePath.clients, <FaUserFriends />],
    ["Clients Review", RoutePath.clientsReview, <FaUserFriends />],
  ],
  // [["Gallery", RoutePath.gallery, <RiGalleryFill />]],
  [
    ["Blogs", "", <FaBloggerB />],
    ["Blogs Content", RoutePath.blogsContent, <SiBloglovin />],
    ["Blog List", RoutePath.blogList, <TiThListOutline />],
  ],
  [
    ["Career Content", "", <FaBriefcase />],
    ["Career", RoutePath.career, <MdHomeWork />],
    ["Jobs", RoutePath.jobs, <TiThListOutline />],
  ],
  // [["Career", RoutePath.career, <MdHomeWork />]],
  [["Contact", RoutePath.contact, <MdPermContactCalendar />]],
  [["Footer", RoutePath.footer, <CgDockBottom />]],
];

export const sideBarNavigationModerator = [
  //title, url, content
  [
    ["Projects", "", <FaProjectDiagram />],
    ["Projects Content", RoutePath.projectContent, <MdContentPaste />],
    ["Project List", RoutePath.projectList, <FaThList />],
  ],
  [
    ["Teams", "", <SiMicrosoftteams />],
    ["Team Content", RoutePath.teamContent, <MdPersonSearch />],
    ["Team List", RoutePath.teamList, <RiTeamFill />],
  ],
  [["Gallery", RoutePath.gallery, <RiGalleryFill />]],
  [
    ["Blogs", "", <FaBloggerB />],
    ["Blogs Content", RoutePath.blogsContent, <SiBloglovin />],
    ["Blog List", RoutePath.blogList, <TiThListOutline />],
  ],
];

export const getToken = () => {
  const tempToken = sessionStorage.getItem("ebc202c5c66c906f41dfee622fb64221")
    ? sessionStorage.getItem("ebc202c5c66c906f41dfee622fb64221")
    : "asdf";

  let charPlace = tempToken.indexOf(".");
  let payLoad = tempToken.slice(0, charPlace + 1);
  let legitToken = tempToken.slice(charPlace + 11);

  return payLoad + legitToken;
};
